import React from 'react';
import { Row } from 'react-bootstrap';
import {
  buildWhereForDates,
  FormCol,
  FormFilterCard,
  FieldInput,
  FieldDateRanger,
  FieldSelectIsActive,
} from 'motion-components';
import { useTranslation } from 'react-i18next';
import { FieldSelectCollector } from 'shared-pages';
import { FieldSelectRouteState } from 'shared-pages/components/field-select/fs-route-state';
import { useRootStore } from 'store';

/* ----------------------- Διαχείριση Φίλτρων ------------------------------ */
export function buildWhereFromFilterValues(values): string {
  // Φτιάξε το where για το graphql
  let where = {};
  if (values) {
    if (values.searchText) {
      const searchText = '%' + values.searchText + '%';
      const likeObj = { $like: searchText };
      where = {
        ...where,
        $or: [
          { code: likeObj },
          { '$vehicle.collector.name$': likeObj },
          { '$vehicle.plateNumber$': likeObj },
          { '$driver.name$': likeObj },
          { notes: likeObj },
        ],
      };
    }
    if (values.isActive !== undefined && values.isActive !== null && values.isActive !== '') {
      where = { ...where, isActive: values.isActive };
    }
    if (values.startDate || values.endDate) {
      where = {
        ...where,
        ...buildWhereForDates(values.startDate, values.endDate, 'routeDate'),
      };
    }
    if (values.statusId) {
      where = { ...where, statusId: values.statusId };
    }
    if (values.collectorId) {
      where = { ...where, collectorId: values.collectorId };
    }
  }
  return JSON.stringify(where);
}

/* ----------------------- Filter Form ------------------------------ */
export const Filters = ({ onChange, initialValues, disable = false }) => {
  //
  const { appStore } = useRootStore();
  const { i18n, t } = useTranslation();
  function handleFiltersSubmit(values, { setSubmitting }) {
    if (disable) return;
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }

  const filters = {
    searchText: initialValues?.searchText ?? '',
    isActive: initialValues?.isActive ?? null,

    addressNomos: initialValues?.addressNomos ?? undefined,
    startDate: initialValues?.startDate ?? null,
    endDate: initialValues?.endDate ?? null,
    statusId: initialValues?.statusId ?? null,
    collectorId: initialValues?.collectorId ?? null,
  };

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        <FieldInput
          as={FormCol}
          name="searchText"
          label={t('Αναζήτηση (Κωδικός, Συλλέκτης, Όχημα, Οδηγός)')}
          type="search"
          disable={disable}
          tooltip={'Κωδικό, πινακίδα, οδηγός, συλλέκτης'}
        />
        {appStore.isPlatformOwner && <FieldSelectCollector as={FormCol} />}
        <FieldDateRanger as={FormCol} label="Δρομολόγηση από" name="startDate" name2="endDate" />
        <FieldSelectRouteState name="statusId" as={FormCol} />
        <FieldSelectIsActive label={t('Ενεργές Εγγραφές')} disable={disable} />
      </Row>
    </FormFilterCard>
  );
};
